function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7.94,
  d: "M51.09 26.23L30.62 5.76 10.15 26.23M30.62 64V5.76"
});

function SvgArrowUpLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+YXJyb3ctdXAtbGluZTwvdGl0bGU+PHBvbHlsaW5lIHBvaW50cz0iNTEuMDkgMjYuMjMgMzAuNjIgNS43NiAxMC4xNSAyNi4yMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI3Ljk0Ii8+PGxpbmUgeDE9IjMwLjYyIiB5MT0iNjQiIHgyPSIzMC42MiIgeTI9IjUuNzYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNy45NCIvPjwvc3ZnPg==";
export { SvgArrowUpLine as ReactComponent };